import { FieldError, FieldErrors, UseFormRegister } from "react-hook-form"

interface FormControlProps {
   label: string
   field: string
   type?: "text" | "email" | "password" | "tel"
   register: UseFormRegister<any>
   errors: FieldErrors
   className?: string
   disabled?: boolean
}

export function InputFormControl({
   register,
   field,
   label,
   type = "text",
   errors,
   className = "",
   disabled = false,
}: FormControlProps) {
   const error = errors[field] as FieldError

   return (
      <div className={`form-control ${className}`}>
         {label && (
            <label className="label">
               <span className="label-text">{label}</span>
            </label>
         )}
         <input
            type={type}
            className={`input input-bordered w-full ${error ? "input-error" : ""}`}
            disabled={disabled}
            {...register(field)}
         />
         {error && <div className="text-error mt-1">{error.message}</div>}
      </div>
   )
}
